<template lang="pug">
div
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

  template(v-else)
    v-row(no-gutters :style="`min-height: ${viewHeight};`")
      v-col.px-8.shrink.white
        div.sticky(style="width: 200px; top: 106px;")
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 0 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(0)") Settings
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 1 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(1)") Insights
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 2 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(2)") Delivery methods
          .text-md.font-semibold.px-6.py-2.round-md.mb-2.no-wrap(:class="step === 3 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(3)") Thank you message

      v-col.grow.neutral200
        v-container.pa-8(fluid style="max-width:1200px")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="goBack()" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              .text-2xl.font-semibold.neutral700--text {{ offer.name }}

          v-window(v-model="step" touchless)
            v-window-item(:value="0")
              offer-settings(ref="setoffers" @updated="updateSetOffers($event)" @error="isLoading = false")
            v-window-item(:value="1")
              offer-insights
            v-window-item(:value="2")
              delivery-methods(ref="deliveryMethods" @updated="goBack(true)" @error="isLoading = false")
            v-window-item(:value="3")
              thankyou-message(ref="thankYouMessage" @updated="goBack(true)" @error="isLoading = false")

          v-footer.white.py-3.px-10(app inset padless elevation="3")
            v-spacer
            y-button(label="Done" color="neutral700" dark :loading="isLoading" @click="goBack")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OfferSettings from '@/components/clinic/marketing/OfferSettings.vue'
import OfferInsights from '@/components/clinic/marketing/OfferInsights.vue'
import DeliveryMethods from "@/components/clinic/marketing/DeliveryMethods.vue"
import ThankyouMessage from "@/components/clinic/marketing/ThankyouMessage.vue"

export default {
  name: 'CreateOffer',
  components: { ThankyouMessage, DeliveryMethods, OfferSettings, OfferInsights },
  props: ['id'],
  data () {
    return {
      isLoading: false,
      isFetching: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedStep: 'marketing/getOfferDetailsStep',
      offer: 'marketing/getOffer',
      displaySize: 'ui/getDisplaySize'
    }),
    step: {
      get () {
        return this.storedStep
      },
      set (val) {
        this.$store.commit('marketing/setOfferDetailsStep', val)
      }
    },
    viewHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '130vh'
        case 'x-small':
          return '114vh'
        case 'small':
          return '106vh'
        case 'medium':
          return '92vh'
        case 'large':
          return '81vh'
        case 'x-large':
          return '81vh'
        default:
          return '81vh'
      }
    }
  },
  mounted () {
    this.fetchOffers()
    this.fetchSettings()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOffers () {
      this.isFetching = true
      let params = { expand: 'purchase_products,free_products' }
      this.$axios.get(`/marketing/${this.company.slug}/offers/${this.id}`, params)
        .then(resp => {
          this.$store.commit('marketing/setOffer', resp.data)
          this.fetchDeliverance(resp.data.id)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchDeliverance (id) {
      this.$axios.get(`/marketing/${this.company.slug}/offers/${id}/blasts`)
        .then(resp => {
          if (resp.data.results.length) {
            this.$store.commit('marketing/setBlasts', resp.data.results)
          }
        })
        .catch(() => {})
    },
    fetchSettings () {
      this.$axios.get(`/marketing/${this.company.slug}`)
        .then(resp => {
          this.$store.commit('marketing/setMarketingSettings', resp.data)
        })
        .catch(() => {})
    },
    updateSetOffers (id) {
      this.isLoading = false
      this.step = 1
      if (!this.id) {
        this.$router.push(`/admin/clinic/marketing/offer/create/${id}`)
      }
    },
    goToWindow (step) {
      if (this.step !== step) {
        this.step = step
      }
    },
    async goBack (skipSaving = false) {
      if (this.step === 2 && !skipSaving) {
        this.isLoading = true
        await this.$refs.deliveryMethods.saveData()
        return
      }
      if (this.step === 3 && !skipSaving) {
        this.isLoading = true
        await this.$refs.thankYouMessage.saveData()
        return
      }
      this.$router.push('/admin/clinic/marketing')
    },
  },
  beforeDestroy () {
    this.$store.commit('marketing/resetMarketingOffer')
  }
}
</script>

<style scoped>
</style>